import { useEffect } from 'react';
import { useGameStore } from '@/state/gameStore';
import { loadHydrants } from '@/data/hydrants';
import { getRadiusKm } from '@/data/leveling';

/**
 * Loads hydrants for the current home city + level radius into the store.
 * Re-runs when the home city changes or the level changes (radius growth).
 *
 * Uses an AbortController so unmount / re-fire cancels in-flight Overpass
 * requests. Falls back to a synthetic grid silently — see data/hydrants.ts.
 */
export function useHydrantsLoader() {
  const homeCity = useGameStore((s) => s.homeCity);
  const level = useGameStore((s) => s.level);
  const setHydrants = useGameStore((s) => s.setHydrants);

  useEffect(() => {
    if (!homeCity) return;
    const ctrl = new AbortController();
    const radiusKm = getRadiusKm(level);
    void loadHydrants(homeCity.center, radiusKm, ctrl.signal).then((hydrants) => {
      if (ctrl.signal.aborted) return;
      setHydrants(hydrants);
    });
    return () => ctrl.abort();
  }, [homeCity, level, setHydrants]);
}
